import buildRequestFilter from "./buildRequestFilter";
import wordings from './wordings';
import facetList from "./facetList";

function buildFrom(current, resultsPerPage) {
  if (!current || !resultsPerPage) return;
  return (current - 1) * resultsPerPage;
}

function buildSort(sortDirection, sortField) {
  if (sortDirection && sortField) {
    // return [{ [`${sortField}.keyword`]: sortDirection }];
    return [{ [`${sortField}`]: sortDirection }];
  }
}

function buildMatch(searchTerm) {
  return searchTerm
    ? {
        // multi_match: {
        simple_query_string: { // doc https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-simple-query-string-query.html
          query: searchTerm,
          fields: ((window.elastic_index && window.elastic_index != 'archivesbrest') ? ['u_title'] : ["titre", "analyse", "observations"]),
          flags: "FUZZY|ESCAPE|PHRASE",
          fuzzy_max_expansions: 2,
          // analyzer: 'french', // @todo ?
          // default_operator: 'AND',
        }
      }
    : { match_all: {} };
}

/*

  Converts current application state to an Elasticsearch request.

  When implementing an onSearch Handler in Search UI, the handler needs to take the
  current state of the application and convert it to an API request.

  For instance, there is a "current" property in the application state that you receive
  in this handler. The "current" property represents the current page in pagination. This
  method converts our "current" property to Elasticsearch's "from" parameter.

  This "current" property is a "page" offset, while Elasticsearch's "from" parameter
  is a "item" offset. In other words, for a set of 100 results and a page size
  of 10, if our "current" value is "4", then the equivalent Elasticsearch "from" value
  would be "40". This method does that conversion.

  We then do similar things for searchTerm, filters, sort, etc.
*/
export default function buildRequest(state) {
  const {
    current,
    filters,
    resultsPerPage,
    searchTerm,
    sortDirection,
    sortField
  } = state;

  const sort = buildSort(sortDirection, sortField);
  const match = buildMatch(searchTerm);
  const size = resultsPerPage;
  const from = buildFrom(current, resultsPerPage);
  const filter = buildRequestFilter(filters);

  const aggs = facetList.reduce((acc, field) => {
    acc[field] = {
      terms: {
        field,
        size: 10000,
        missing: wordings.emptyLabel
      }
    };
    return acc;
  }, {});

  /*
  if (filter) {
    filter.push({
      bool: {
        must: {
          exists: {
            field: 'nombreDImage',
          }
        }
      }
    });
  }
  */

  const body = {
    // Static query Configuration
    // --------------------------
    // https://www.elastic.co/guide/en/elasticsearch/reference/7.x/search-request-highlighting.html
    highlight: {
      fragment_size: 200,
      number_of_fragments: 1,
      fields: {
        titre: {},
        analyse: {},
        observations: {},
      }
    },
    //https://www.elastic.co/guide/en/elasticsearch/reference/7.x/search-request-source-filtering.html#search-request-source-filtering
    // _source: ["id", "intitule", "description"],
    aggs: aggs,

    // Dynamic values based on current Search UI state
    // --------------------------
    // https://www.elastic.co/guide/en/elasticsearch/reference/7.x/full-text-queries.html
    query: {
      bool: {
        must: [match],
        ...(filter && { filter })
      }
    },
    // https://www.elastic.co/guide/en/elasticsearch/reference/7.x/search-request-sort.html
    ...(sort && { sort }),
    // https://www.elastic.co/guide/en/elasticsearch/reference/7.x/search-request-from-size.html
    ...(size && { size }),
    ...(from && { from })
  };

  return body;
}
